import styled from '@emotion/styled';

export const ESmallText = styled.p`
  font-size: var(--font-size-tiny);
  font-weight: var(--font-weight-thin);
`;

export const ERegularText = styled.p`
  font-size: var(--font-size-default);
  font-weight: var(--font-weight-thin);
  color: var(--color-core-black);
  line-height: var(--line-height-paragraph);
`;
